'use client'

import React, { FC, ReactElement } from 'react'
import styles from './WalletUtxos.module.css'
import useSwr from 'swr'
import { fetcher } from '@/utils/fetcher'
import Wallet from '@/utils/wallet'
import { API_URL } from '@/utils/constants'
import Loading from '@/components/circle-loading'
import ItemGrid from '@/components/item-grid'
import UtxoItem from '@/components/utxo-item'
import InfiniteScroll from 'react-infinite-scroll-component'

const LIMIT = 100

const WalletUtxos: FC = (_props): ReactElement => {
	const { data, isLoading } = useSwr(
		`${API_URL}/wallet/${Wallet.balanceAddress()}/all-utxos`,
		fetcher
	)

	const utxos = React.useMemo(() => {
		const confirmed = (data?.utxos || [])
			?.sort((a: any, b: any) => b.value - a.value)
			.map((e: any) => ({ ...e, outpoint: `${e.txid}:${e.vout}` }))

		const unconfirmed = (data?.mempool || [])
			?.sort((a: any, b: any) => b.value - a.value)
			.map((e: any) => ({ ...e, outpoint: `${e.txid}:${e.vout}` }))

		return confirmed.concat(unconfirmed)
	}, [data])

	const renderUtxo = React.useCallback((e: any) => {
		return <UtxoItem utxo={e} key={e.outpoint} link={true} />
	}, [])

	const [size, setSize] = React.useState(0)
	const fetchMore = React.useCallback(async () => setSize((prev) => prev + 1), [])
	const viewData = React.useMemo(() => utxos.slice(0, (1 + size) * LIMIT), [size, utxos])

	if (isLoading) {
		return (
			<div className={styles.loading}>
				<Loading />
			</div>
		)
	}

	return (
		<div className={styles.root}>
			<InfiniteScroll
				className="w-full h-full overflow-hidden"
				dataLength={viewData?.length}
				next={fetchMore}
				hasMore={viewData?.length % LIMIT === 0}
				loader={
					<div className={styles.loading}>
						<Loading />
					</div>
				}
			>
				<ItemGrid className={styles.grid}>{viewData?.map(renderUtxo)}</ItemGrid>
			</InfiniteScroll>
		</div>
	)
}

export default WalletUtxos
